import types from '../types';

const initialState = {
  usersData: [],
  loading: false,
};

const reset2FA = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_RESET_2FA_MESSAGE_START:
      return { ...state, loading: true };

    case types.GET_RESET_2FA_MESSAGE_SUCCESS:
      return { usersData: payload, loading: false };

    case types.GET_RESET_2FA_MESSAGE_FAILURE:
      return { usersData: [], loading: false };

    // case userLogout.SUCCESS:
    //   return initialState;

    default:
      return state;
  }
};

export default reset2FA;
